module.exports = __webpack_public_path__ + "static/media/_turkey.ffeaeaa6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_turkey.svg
// module id = 2358
// module chunks = 7